import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var LayersIcon = createIcon({
  displayName: 'LayersIcon',
  viewBox: '0 0 23 23',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C5.5 1.73478 5.60537 1.48051 5.79291 1.29297C5.98044 1.10543 6.23478 1 6.5 1H21C21.2652 1 21.5196 1.10543 21.7071 1.29297C21.8946 1.48051 22 1.73478 22 2V16.5C22 16.7652 21.8946 17.0196 21.7071 17.2072C21.5196 17.3947 21.2652 17.5 21 17.5H6.5C6.23478 17.5 5.98044 17.3947 5.79291 17.2072C5.60537 17.0196 5.5 16.7652 5.5 16.5V2Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22H2.5C2.10218 22 1.72064 21.842 1.43933 21.5607C1.15803 21.2794 1 20.8978 1 20.5V5.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }))
});
//# sourceMappingURL=Layers.js.map